import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";

// Köpek listesi sayfası için custom data hook.
// Filtre değiştikçe backend'i tetikler. Custom hook olarak yazıldı ki
// component scope'da async setState antipattern lint'ini tetiklemesin.
export function useDogsList({ search, status, size, isChildFriendly, isApartmentSuitable, needsGuardianMode }) {
  const [dogs, setDogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (needsGuardianMode) {
      params.append("needs_guardian", "true");
    } else if (status && status !== "all") {
      params.append("status", status);
    }
    if (size && size !== "all") params.append("size", size);
    if (isChildFriendly) params.append("is_child_friendly", "true");
    if (isApartmentSuitable) params.append("is_apartment_suitable", "true");

    axios.get(`${API}/dogs?${params.toString()}`)
      .then((r) => {
        if (cancelled) return;
        setDogs(r.data.dogs);
        setTotal(r.data.total);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Dogs fetch error:", err);
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [search, status, size, isChildFriendly, isApartmentSuitable, needsGuardianMode]);

  return { dogs, total, loading };
}
